module.exports = __webpack_public_path__ + "img/playNext.bc05e191.svg";